/**
 * Utils for runtime sort for embedding use case
 */
import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import _ from 'lodash';
import { RuntimeSortInput } from '../services/generated/graphql-types';

const getSortParam = (index: number) => `sortCol${index}`;
const getAscendingParam = (index: number) => `asc${index}`;

const MAX_RUNTIME_SORT_INPUTS = 50;

export function getRuntimeSortInput(
    urlSearchParams = getQueryParamsAndQueryString({
        includeSearch: true,
        includeHash: true,
    }).queryParams,
): RuntimeSortInput[] {
    const START_INDEX = 1;
    const result: RuntimeSortInput[] = [];

    for (let index = START_INDEX; index < MAX_RUNTIME_SORT_INPUTS; index++) {
        if (_.get(urlSearchParams, getSortParam(index))) {
            result.push({
                columnName: _.get(urlSearchParams, getSortParam(index)),
                isAscending:
                    _.get(
                        urlSearchParams,
                        getAscendingParam(index),
                    )?.toLowerCase() === 'true',
            });
        } else {
            break;
        }
    }

    return result;
}

/**
 * Read runtime sorts from the URL search string
 */
export function getRuntimeSort(defaultQueryParams?: {
    [key: string]: string[];
}): RuntimeSortInput[] {
    const urlSearchParams = getQueryParamsAndQueryString({
        includeSearch: true,
        includeHash: true
    }).queryParamsMultiValue;

    const combinedParams = {
        ...urlSearchParams,
        ...(defaultQueryParams || {}),
    };

    const transformedParams = Object.fromEntries(
        Object.entries(combinedParams).map((
            [key, val]) => [key, val.length === 1 ? val[0] : val]
        ));

    return getRuntimeSortInput(transformedParams);
}